module.exports = __webpack_public_path__ + "static/media/Slide08.7a13a412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide08.png
// module id = 1630
// module chunks = 0